import { render } from "./MediaBuyingRequest.vue?vue&type=template&id=797e8a20&scoped=true&ts=true"
import script from "./MediaBuyingRequest.vue?vue&type=script&lang=ts"
export * from "./MediaBuyingRequest.vue?vue&type=script&lang=ts"

import "./MediaBuyingRequest.vue?vue&type=style&index=0&id=797e8a20&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797e8a20"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QForm,QInput});
